import { render } from "./KdsOrderCard.vue?vue&type=template&id=58fb5aa2"
import script from "./KdsOrderCard.vue?vue&type=script&lang=js"
export * from "./KdsOrderCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__